export const formatMoney = (value?: number | string, currency: string = 'AUD') => {
  if (value === undefined || value === null || value === '—') return '—'
  const num = typeof value === 'string' ? Number(value) : value
  if (Number.isNaN(num)) return '—'
  try {
    return new Intl.NumberFormat(undefined, {
      style: 'currency',
      currency,
      currencyDisplay: 'narrowSymbol',
      minimumFractionDigits: 2,
      maximumFractionDigits: 2,
    }).format(num)
  } catch {
    const sign = num < 0 ? '-' : ''
    return `${sign}${Math.abs(num).toFixed(2)} ${currency}`
  }
}
